/*
	Resultado da busca da operação
*/
export default (state, { result } = {}) => 
	state.swagger.colaboradores.result = result
	

